module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-11/12"
  }, [_c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-5"
  }, [_c('div', {
    class: _vm.profile.role === 'student' ? 'md:col-span-2' : ''
  }, [_c('p', [_vm._v("Avatar")]), _vm._v(" "), _c('div', {
    staticClass: "flex mt-1 items-center"
  }, [_c('img', {
    staticClass: "rounded-full object-cover h-24 w-24",
    attrs: {
      "src": _vm.getProfile.avatar_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-5"
  }, [_c('button', {
    staticClass: "px-4 py-2 bg-input rounded cursor-pointer text-gray-500",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openPopupChooseAvatar.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            Change Avatar\n          ")])])])]), _vm._v(" "), (_vm.profile.role === 'teacher') ? _c('div', {
    staticClass: "flex flex-col self-end"
  }, [_c('div', [_vm._v("\n        Universe Profile URL\n        "), _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: ({
        content: _vm.tooltip_content,
        placement: 'top',
        classes: ['universe-profile-url'],
      }),
      expression: "{\n            content: tooltip_content,\n            placement: 'top',\n            classes: ['universe-profile-url'],\n          }"
    }],
    staticClass: "fas fa-question-circle text-gray-300 hover:text-primary",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('span', {
    staticClass: "flex items-center rounded rounded-r-none outline-none px-2 text-sm bg-gray-200 text-gray-500 cursor-default"
  }, [_vm._v("\n          universe.parlayideas.com/profiles/\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile_url),
      expression: "profile_url"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none pl-1 pr-4 py-2 w-full rounded rounded-l-none placeholder-gray-300",
    attrs: {
      "placeholder": 'Profile URL',
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile_url)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.profile_url = $event.target.value
      }, function($event) {
        return _vm.checkProfileUrlExistence(_vm.profile_url)
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex items-center rounded-lg space-x-4 mx-auto"
  }, [_c('button', {
    staticClass: "sharing_teacher_url bg-primary text-white rounded-l-none rounded-r-md px-4 py-2 text-sm cursor-pointer",
    attrs: {
      "data-clipboard-text": _vm.sharing_teacher_url
    }
  }, [_c('i', {
    staticClass: "fas fa-copy"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-red-500 italic text-xs"
  }, [_vm._v("\n        " + _vm._s(_vm.profileUrlTaken ? 'Profile URL already taken.' : '') + "\n        " + _vm._s(_vm.profileInvalidChars ?
    'Only lowercase letters, numbers and dashes are allowed.' :
    '') + "\n        " + _vm._s(_vm.profileUrlCannotBeEmpty ?
    'Profile URL cannot be empty and must be between 3 and 99 characters' :
    '') + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('p', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300",
    attrs: {
      "placeholder": 'Name',
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }, function($event) {
        return _vm.checkName(_vm.name)
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-red-500 italic text-xs"
  }, [_vm._v("\n        " + _vm._s(_vm.nameIsRequired ? 'Your name is required' : '') + "\n        " + _vm._s(_vm.nameValidation ?
    'Your name must be between 2 and 99 characters' :
    '') + "\n      ")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Preferred Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferred_name),
      expression: "preferred_name"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300",
    attrs: {
      "placeholder": 'Preferred Name',
      "type": "text"
    },
    domProps: {
      "value": (_vm.preferred_name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.preferred_name = $event.target.value
      }, function($event) {
        return _vm.checkPreferredName(_vm.preferred_name)
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-red-500 italic text-xs"
  }, [_vm._v("\n        " + _vm._s(_vm.preferredNameValidation ?
    'Your preferred name must be between 2 and 99 characters' :
    '') + "\n      ")])]), _vm._v(" "), (_vm.profile.role === 'teacher') ? _c('div', {
    staticClass: "md:col-span-2"
  }, [_c('p', [_vm._v("About")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300 h-28 resize-none",
    attrs: {
      "placeholder": 'Tell us a little bit about yourself',
      "type": "text"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.profile.role === 'teacher') ? _c('div', [_c('p', [_vm._v("Subjects/Topics")]), _vm._v(" "), _c('pl-multiselect', {
    attrs: {
      "options": _vm.subjects,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "preselect-first": false,
      "show-labels": false,
      "placeholder": "Select subjects",
      "label": "name",
      "track-by": "id"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.selectedSubjects && _vm.selectedSubjects.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v("\n            " + _vm._s(_vm.selectedSubjects.length) + " options selected\n          ")]) : _vm._e()]
      }
    }], null, false, 172338859),
    model: {
      value: (_vm.selectedSubjects),
      callback: function($$v) {
        _vm.selectedSubjects = $$v
      },
      expression: "selectedSubjects"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.profile.role === 'teacher') ? _c('div', [_c('p', [_vm._v("Grade Levels")]), _vm._v(" "), _c('pl-multiselect', {
    attrs: {
      "options": _vm.gradeLevels,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "preselect-first": false,
      "show-labels": false,
      "placeholder": "Select grades",
      "label": "grade",
      "track-by": "id"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.selectedGradeLevels && _vm.selectedGradeLevels.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v("\n            " + _vm._s(_vm.selectedGradeLevels.length) + " options selected\n          ")]) : _vm._e()]
      }
    }], null, false, 3351546324),
    model: {
      value: (_vm.selectedGradeLevels),
      callback: function($$v) {
        _vm.selectedGradeLevels = $$v
      },
      expression: "selectedGradeLevels"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "my-5"
  }, [_c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": _vm.disabledButton
    },
    on: {
      "click": function($event) {
        return _vm.updateProfile()
      }
    }
  }, [_vm._v("\n        Save Changes\n      ")])])]), _vm._v(" "), (_vm.show_choose_avatar_modal) ? _c('choose-avatar', {
    on: {
      "close": function($event) {
        _vm.show_choose_avatar_modal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7f48452d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/profile/profileTabs/basicInfoTab.vue
// module id = 1602
// module chunks = 61